var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.main_class},[_c('div',{class:_vm.line_class,style:({width: _vm.line_width})}),(_vm.progress_text)?_c('div',{class:_vm.text_class},[_vm._v(_vm._s(_vm.progress_text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }